module.exports = "<p>\r\n  configuration-examples-landing-page works!\r\n</p>\r\n"